// index.ts — entry point for the encounter-minimap bundle (member of the post-template-tail
// aggregate). Attaches + self-runs window.ftMountEncounterMinimaps(root?), the placeholder scanner.
//
// Mount contract (mirrors ftMountCarousels): PHP / the blob-first card emit
//   <div class="ft-encounter-minimap-mount" data-campaign-id="…" data-encounter-id="…"
//        data-encounter-name="…" data-perspective="player|"></div>
// The scanner marks the mount and renders from the browser-owned graph store (store.ts), which seeds from
// the page's boot state (window.FateTide.minimapGraph) and is kept current by WebSocket pushes — no reads.
// AJAX re-hydration is by explicit scoped re-invocation from loadPostFunctions — deliberately NOT a
// MutationObserver.

import { installMinimapRepaint, mountEncounterMinimap } from './minimap';
import { installMinimapStoreListeners } from './store';

declare global {
    interface Window {
        ftMountEncounterMinimaps?: (root?: Element | Document) => void;
    }
}

function ftMountEncounterMinimaps(root?: Element | Document): void {
    const scope: Element | Document = root || document;
    const mounts = scope.querySelectorAll('.ft-encounter-minimap-mount:not([data-ft-minimap-mounted])');
    for (let i = 0; i < mounts.length; i++) {
        const el = mounts[i] as HTMLElement;
        el.setAttribute('data-ft-minimap-mounted', '1'); // mark first so a thrown render never loops
        void mountEncounterMinimap(el).catch((e) => console.warn('ftMountEncounterMinimaps: mount failed', e));
    }
}

window.ftMountEncounterMinimaps = ftMountEncounterMinimaps;
installMinimapStoreListeners();
installMinimapRepaint();

if (document.readyState !== 'loading') {
    ftMountEncounterMinimaps();
} else {
    document.addEventListener('DOMContentLoaded', () => ftMountEncounterMinimaps());
}
